import Vue from "vue"
Vue.mixin({
  methods: {
    /** 点击 [律邦法务管理系统3.1] 返回首页*/
    $goHome() {
		this.$router.push({name:'index'})
    },
  }
})



// WEBPACK FOOTER //
// ./src/mixin/goHome.js